import { render, staticRenderFns } from "./Commandes.vue?vue&type=template&id=f0eb3928&"
import script from "./Commandes.vue?vue&type=script&lang=js&"
export * from "./Commandes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports